import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { PermissionGroup } from "../types/PermissionGroup";
import { env } from "../utils/env";
import { PagedResponse } from "../types/Common";
import { ROUTE } from "../routes";
import { useNavigate } from "react-router-dom";

const fetch = (authHeader: string) => () =>
  axios.get<PagedResponse<PermissionGroup[]>>(`${env.verifyServiceUrl}user/groups/`, {
    headers: {
      Authorization: authHeader,
    },
  });

export const usePermissionGroups = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["permissionGroups"], fetch(authHeader), {retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
